import { Box, Button, TextField } from "@mui/material"
import useMediaQuery from "@mui/material/useMediaQuery"
import { useFormik } from "formik"
import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import * as yup from "yup"
import Header from "../../components/Header"
import UsersApi from "../../services/api/users"

const Form = () => {
	const navigate = useNavigate()
	const userModule = UsersApi()
	const location = useLocation()
	const isNonMobile = useMediaQuery("(min-width:600px)")

	const [isEdit, setIsEdit] = useState(false)
	const [userId, setUserId] = useState("")

	const formik = useFormik({
		initialValues: initialValues,
		validationSchema: checkoutSchema,

		onSubmit: async (values) => {
			if (isEdit) {
				editUser(values)
			} else {
				createUser(values)
			}
		},
	})

	const createUser = async (values) => {
		const response = await userModule.createUser(values)

		console.log("New user created:", response)
		navigate("/users")
	}

	const editUser = async (values) => {
		const response = await userModule.editUser(userId, values)

		console.log("User updated successfully:", response)
		navigate("/users")
	}

	useEffect(() => {
		if (location.state) {
			const user = location.state.user

			if (user) {
				formik.setValues({
					...formik.values,
					name: user.name,
					email: user.email,
					contact: user.contact,
					password: user.password,
				})

				setIsEdit(true)
				setUserId(user.id)
			}
		}
	}, [])

	return (
		<Box m="20px">
			<Header title="CREATE USER" subtitle="Create a New User Profile" />

			<Box
				sx={{
					width: isNonMobile ? "60vw" : "100vw",
				}}
			>
				<form onSubmit={formik.handleSubmit}>
					<Box
						display="grid"
						gap="30px"
						gridTemplateColumns="repeat(4, minmax(0, 1fr))"
						sx={{
							"& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
						}}
					>
						<TextField
							fullWidth
							variant="filled"
							type="text"
							label="Name"
							autoComplete="off"
							onBlur={formik.handleBlur}
							onChange={formik.handleChange}
							value={formik.values.name}
							name="name"
							error={!!formik.touched.name && !!formik.errors.name}
							helperText={formik.touched.name && formik.errors.name}
							sx={{ gridColumn: "span 4" }}
						/>

						<TextField
							fullWidth
							variant="filled"
							type="text"
							label="Email"
							autoComplete="off"
							onBlur={formik.handleBlur}
							onChange={formik.handleChange}
							value={formik.values.email}
							name="email"
							error={!!formik.touched.email && !!formik.errors.email}
							helperText={formik.touched.email && formik.errors.email}
							sx={{ gridColumn: "span 4" }}
						/>
						<TextField
							fullWidth
							variant="filled"
							type="text"
							label="Contact Number"
							autoComplete="off"
							onBlur={formik.handleBlur}
							onChange={formik.handleChange}
							value={formik.values.contact}
							name="contact"
							error={!!formik.touched.contact && !!formik.errors.contact}
							helperText={formik.touched.contact && formik.errors.contact}
							sx={{ gridColumn: "span 4" }}
						/>

						<TextField
							fullWidth
							variant="filled"
							type="password"
							label="Password"
							autoComplete="off"
							onBlur={formik.handleBlur}
							onChange={formik.handleChange}
							value={formik.values.password}
							name="password"
							error={!!formik.touched.password && !!formik.errors.password}
							helperText={formik.touched.password && formik.errors.password}
							sx={{ gridColumn: "span 1" }}
						/>
					</Box>
					<Box display="flex" justifyContent="end" mt="20px">
						<Button type="submit" color="secondary" variant="contained">
							{isEdit ? "Update User" : "Create New User"}
						</Button>
					</Box>
				</form>
			</Box>
		</Box>
	)
}

const phoneRegExp =
	/^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/

const checkoutSchema = yup.object().shape({
	name: yup.string().required("required"),
	email: yup.string().email("invalid email").required("required"),
	contact: yup
		.string()
		.matches(phoneRegExp, "Phone number is not valid")
		.required("required"),
	password: yup.string().required("required"),
})

const initialValues = {
	name: "",
	email: "",
	contact: "",
	password: "",
}

export default Form
